import { createReducer, on } from '@ngrx/store';
import * as AuthActions from '../actions/auth.actions';
import { AuthState } from '../auth-state';
import { anonymousUser } from '../models/user';

export const initialState: AuthState = {
  user: anonymousUser,
  impersonatedClientId: undefined,
  isLoaded: false,
  isSignedInClientValid: false,
  signedInClientId: undefined
};

export const reducer = createReducer(
  initialState,

  on(AuthActions.loginSuccess, (state, { userInfo, hasValidAccessToken }) => {
    const user = { ...state.user, ...userInfo, hasValidAccessToken };
    return { ...state, user };
  }),

  on(AuthActions.tokenInvalidated, state => {
    const user = { ...state.user, hasValidAccessToken: false };
    return { ...state, user };
  }),

  on(AuthActions.userProfileSuccess, (state, { userInfo }) => {
    const user = { ...state.user, ...userInfo };
    return { ...state, user };
  }),

  on(AuthActions.userInfoSuccess, (state, { attributes }) => {
    const user = { ...state.user, ...attributes };
    return { ...state, user, isLoaded: true };
  }),

  on(AuthActions.impersonateClient, (state, { impersonatedClientId }) => ({
    ...state,
    impersonatedClientId,
    isLoaded: false
  })),

  on(AuthActions.rehydrateState, (state, action) => {
    if (Object.keys(action).length <= 1) return state;

    const { type: _, ...rehydratedState } = action;

    return {
      ...state,
      ...rehydratedState
    };
  }),

  on(AuthActions.signInClient, (state, { signedInClientId, isValid }) => ({
    ...state,
    signedInClientId,
    isSignedInClientValid: isValid
  })),

  on(AuthActions.validateSignedInClient, (state, _) => ({
    ...state,
    isSignedInClientValid: true
  }))
);
